import PropTypes from "prop-types";
import React from "react";
// components
import { LoadingScreen } from "src/components/loading-screen";
//
import { AuthContext } from "./auth-context";

// ----------------------------------------------------------------------

export function AuthConsumer({ children }) {
    return (
        <AuthContext.Consumer>
            {(auth) => ( auth.loading ? <LoadingScreen/> : children )}
        </AuthContext.Consumer>
    );
}

AuthConsumer.propTypes = {
    children: PropTypes.node
};
